import { OrganizationUser } from '@enview/interface/types/OrganizationUser';
import { Team, TeamMembership } from '@enview/interface/types/Team';

const filteredTeamMembershipsForSelector = (
  teamMeberships?: TeamMembership[],
  orgUser?: OrganizationUser,
  teamModeOrgId?: number,
): Team[] => {
  if (!teamMeberships || !teamModeOrgId || !orgUser || teamMeberships.length === 0) {
    return [];
  }
  return teamMeberships
    .map((tm) => tm.team)
    .sort((team1, team2) => {
      const userTeamId = orgUser && orgUser.teamId;
      if (team1.id === userTeamId) {
        return -1;
      }
      if (team2.id === userTeamId) {
        return 1;
      }
      return team1.name.localeCompare(team2.name);
    })
    .filter(
      (team) =>
        team.organizationId === teamModeOrgId ||
        (orgUser && team.id === orgUser.teamId),
    );
};

// Workspace-scoped fields (Workflow Status, Priority, Assignee) need a single team to
// read/write against on pages that can show bills from several of the user's workspaces
// at once. Prefers the user's current team mode (the workspace switcher in the nav) when
// the bill actually belongs to it — this is the app's existing "workspace being viewed
// from" concept, not something new. Falls back to the first of the user's own workspaces
// (already ordered home-team-first) that the bill belongs to when team mode doesn't apply
// (e.g. viewing a bill from a page that spans workspaces other than the active one).
// Returns undefined if the bill isn't in any workspace the user belongs to.
export const getPrimaryWorkspaceId = (
  userWorkspaces: Team[],
  billWorkspaceIds: number[],
  currentTeamModeId?: number,
): number | undefined => {
  if (currentTeamModeId && billWorkspaceIds.includes(currentTeamModeId)) {
    return currentTeamModeId;
  }
  return userWorkspaces.find((workspace) => billWorkspaceIds.includes(workspace.id))
    ?.id;
};

export default filteredTeamMembershipsForSelector;
